import { apiClient, apiPost, apiGet, apiDelete } from "@/lib/api/client";

const BASE = "/contact";

export const contactApi = {
  submit: (body: Record<string, unknown>) => apiPost<{ data: Record<string, unknown> }>(BASE, body),

  bulkDeleteSubmissions: (ids: string[]) => apiDelete<{ data: number }>(`${BASE}/contact/submissions/bulk-delete`, { data: { ids } }),

  getSubmissionsStats: () => apiGet<{ data: Record<string, unknown> }>(`${BASE}/contact/submissions/stats`),

  exportSubmissions: (format = "CSV") => apiGet<{ data: unknown }>(`${BASE}/contact/submissions/export?format=${format}`),
};